export default "__VITE_ASSET__CN$zKF22__"